import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap";

const points = (count) => `${count} ${count === 1 ? "point" : "points"}`;

// Asks before a shop item's Buy form spends points; confirming submits that form
export default class extends Controller {
  static targets = ["modal", "title", "summary", "buyButton"];
  static values = { balance: Number };

  confirm(event) {
    event.preventDefault();
    this.form = event.currentTarget;
    this.bought = false;
    const { name, cost } = event.params;
    this.titleTarget.textContent = `Buy ${name}?`;
    this.summaryTarget.textContent = `It costs ${points(cost)}, leaving you ${points(this.balanceValue - cost)}. You can't undo a purchase.`;
    this.buyButtonTarget.textContent = `Buy for ${points(cost)}`;
    this.buyButtonTarget.disabled = false;
    Modal.getOrCreateInstance(this.modalTarget).show();
  }

  // submit() fires no submit event, so the form goes without asking again
  buy() {
    this.bought = true;
    this.buyButtonTarget.disabled = true;
    this.form.submit();
  }

  // Bootstrap returns focus only to a modal opened through data-bs-toggle, so
  // a pupil who backs out goes back to the item rather than the top of the page
  restoreFocus() {
    if (!this.bought) this.form.querySelector("button").focus();
  }
}
